import { useTranslate } from "helpers";
import { Button } from "ui/components/Button/Button";
import Alert from "ui/components/Alert/Alert";
import { ImportTemplateStepProps } from "./types";

/** Korak 1 — preuzimanje Excel predloška. */
const ImportTemplateStep: React.FC<ImportTemplateStepProps> = (props) => {
  const { isDownloadingTemplate, onDownloadTemplate } = props;

  const { t } = useTranslate();

  return (
    <div className="flex items-center justify-center px-4 min-h-[60vh]">
      <div className="w-full max-w-xl space-y-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
            {t("admin.fleet.vehicle.import.xlsx.title")}
          </h1>
          <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
            {t("admin.fleet.vehicle.import.xlsx.description")}
          </p>
        </div>

      

        <div className="flex justify-center">
          <Button
            variant="primary"
            onClick={onDownloadTemplate}
            loading={isDownloadingTemplate}
            // startIcon="/media/icons/document-download.svg"
            size="full"
          >
            {t("admin.fleet.vehicle.import.xlsx.template.download")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImportTemplateStep;
